<template>
  <div v-if="showModal"
       class="modal false z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center">
    <div class="absolute w-full h-full bg-gray-900 opacity-50 modal-overlay"
         @click="showModal = false"></div>
    <div class="z-50 w-11/12 mx-auto bg-white rounded shadow-lg modal-container md:max-w-xl">
      <div class="flex-auto">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <Form v-if="step === 'CHAT_ID'"
                class="text-base leading-relaxed"
                :validation-schema="schema"
                @submit="submit">
            <!-- header -->
            <div class="flex justify-between items-start p-5 rounded-t border-b dark:border-gray-600">
              <h3 class="text-lg font-semibold text-gray-900 lg:text-xl dark:text-white">
                {{ $lang.app.ADD_TELEGRAM_USER_ID }}
              </h3>
              <button
                  @click="showModal = false"
                  type="button"
                  class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5
                ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white">
                <XIcon class="w-5 h-5"/>
              </button>
            </div>
            <!-- body -->
            <div class="p-6 modal-body custom-scrollbar overflow-y-auto">
              <div class="mb-4">
                <span class="font-medium mr-2">{{ $lang.app.GET_TELEGRAM_USER_ID }}</span>
                <a :href="telegramIdGetterBotUrl" target="_blank" class="text-blue-500 font-medium">Get My ID</a>
                <span class="block font-normal text-sm text-gray-600">({{ $lang.app.COPY_USER_ID_HERE }})</span>
              </div>
              <div class="mb-4">
                <div class="mb-1">
                  <label class="block text-gray-500 text-sm" for="chat-id-input">
                    {{ $lang.app.TELEGRAM_USER_ID }}:
                  </label>
                </div>
                <div class="flex flex-col">
                  <Field id="chat-id-input" type="text" name="chatId" v-model="form.chatId"
                         class="w-full border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"/>
                  <ErrorMessage name="chatId" class="text-xs text-red-400"/>
                </div>
              </div>

            </div>
            <!-- footer -->
            <div class="flex items-center p-6 space-x-2 rounded-b border-t border-gray-200 dark:border-gray-600">
              <button
                  type="submit"
                  class="relative text-white bg-indigo-700 hover:bg-indigo-800 focus:ring-2 focus:outline-none
                  focus:ring-indigo-300 font-medium rounded text-md px-4 py-2 text-center"
                  :disabled="submitting"
              >
                {{ $lang.app.SAVE }}
                <div v-if="submitting"
                     class="absolute z-10 rounded w-full h-full top-0 left-0 bg-indigo-700 flex items-center justify-center">
                  <div class="block animate-spin">
                    <RefreshIcon class="w-6 h-6 mirror-y"/>
                  </div>
                </div>
              </button>
              <button
                  @click="showModal = false"
                  type="button"
                  class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-2 focus:outline-none focus:ring-indigo-300
                  rounded border border-gray-200 text-md font-medium px-4 py-2 hover:text-gray-900 focus:z-10"
              >
                {{ this.$lang.app.CANCEL }}
              </button>
            </div>
          </Form>
          <Form v-if="step === 'ACTIVATION'"
                class="text-base leading-relaxed"
                :validation-schema="activationSchema"
                @submit="activate">
            <!-- header -->
            <div class="flex justify-between items-start p-5 rounded-t border-b dark:border-gray-600">
              <h3 class="text-lg font-semibold text-gray-900 lg:text-xl dark:text-white">
                {{ $lang.app.ACTIVATION_TELEGRAM }}
              </h3>
              <button
                  @click="showModal = false"
                  type="button"
                  class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5
                ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white">
                <XIcon class="w-5 h-5"/>
              </button>
            </div>
            <!-- body -->
            <div class="p-6 modal-body custom-scrollbar overflow-y-auto">
              <div class="mb-4">
                <span class="mr-2">{{ $lang.app.ACTIVATION_CODE_SENT_TO_TELEGRAM }}</span>
              </div>
              <div class="mb-4">
                <div class="mb-1">
                  <label class="block text-gray-500 text-sm" for="activation-code-input">
                    {{ $lang.app.ACTIVATION_CODE }}:
                  </label>
                </div>
                <div class="flex flex-col">
                  <Field id="activation-code-input" type="text" name="activationCode"
                         v-model="activationForm.activationCode"
                         class="w-full border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"/>
                  <ErrorMessage name="activationCode" class="text-xs text-red-400"/>
                </div>
              </div>

            </div>
            <!-- footer -->
            <div class="flex items-center p-6 space-x-2 rounded-b border-t border-gray-200 dark:border-gray-600">
              <button
                  type="submit"
                  class="relative text-white bg-indigo-700 hover:bg-indigo-800 focus:ring-2 focus:outline-none
                  focus:ring-indigo-300 font-medium rounded text-md px-4 py-2 text-center"
                  :disabled="submitting"
              >
                {{ $lang.app.SEND }}
                <div v-if="submitting"
                     class="absolute z-10 rounded w-full h-full top-0 left-0 bg-indigo-700 flex items-center justify-center">
                  <div class="block animate-spin">
                    <RefreshIcon class="w-6 h-6 mirror-y"/>
                  </div>
                </div>
              </button>
              <button
                  @click="step = 'CHAT_ID'"
                  type="button"
                  class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-2 focus:outline-none focus:ring-indigo-300
                  rounded border border-gray-200 text-md font-medium px-4 py-2 hover:text-gray-900 focus:z-10"
              >
                {{ this.$lang.app.BACK }}
              </button>
              <button
                  @click="showModal = false"
                  type="button"
                  class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-2 focus:outline-none focus:ring-indigo-300
                  rounded border border-gray-200 text-md font-medium px-4 py-2 hover:text-gray-900 focus:z-10"
              >
                {{ this.$lang.app.CANCEL }}
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Field, Form, ErrorMessage} from 'vee-validate'
import * as yup from "yup";
import telegramApi from "../../../api/employee/telegram";

export default {
  props: {
    resolution: Object
  },
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  data() {
    return {
      showModal: false,
      step: 'CHAT_ID',

      telegramIdGetterBotUrl: null,
      submitting: false,
      form: {
        chatId: '',
      },
      schema: yup.object({
        chatId: yup.string().required()
      }),

      activationForm: {
        activationCode: ''
      },
      activationSchema: yup.object({
        activationCode: yup.string().required()
      }),
    };
  },
  created() {
    this.fetchTelegramIdGetterBotUrl()
  },
  methods: {
    fetchTelegramIdGetterBotUrl() {
      telegramApi.idGetterBotUrl().then(res => {
        this.telegramIdGetterBotUrl = res.url
      })
    },
    submit(values, actions) {
      this.submitting = true
      telegramApi.setChatId(this.form)
          .then(() => {
            this.step = 'ACTIVATION'
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.setValidationErrors(actions, error.response.data.errors)
            } else {
              this.$snotify.error(error)
            }
          }).finally(() => {
            this.submitting = false
          })
    },
    activate(values, actions) {
      this.submitting = true
      telegramApi.activate(this.activationForm)
          .then(() => {
            this.showModal = false
            this.$emitter.emit('refresh-profile')
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.setValidationErrors(actions, error.response.data.errors)
            } else {
              this.$snotify.error(error)
            }
          }).finally(() => {
        this.submitting = false
      })
    }
  },
  beforeMount() {
    this.$emitter.on('open-telegram-form-modal', () => {
      this.showModal = true
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-telegram-form-modal')
  }
}
</script>
